module.exports = __webpack_public_path__ + "static/media/page03_two_boys.17243fb5.png";